import { createContext } from '@woorcs/utils'

import { InspectionFormEnvironment } from '../../InspectionForm'

export type InspectionFormContext = InspectionFormEnvironment

export const [InspectionFormContextProvider, useInspectionFormContext] =
  createContext<InspectionFormContext>()
